<template>
  <div class="dialog-app-panel" :class="dialogShow ? 'dialog-show' : ''">
    <app-panel
      :isExpand="dialogShow"
      title="一键配置"
      :transparent="true"
      isScreen
      screenClass="screenT"
      @cancel="dialogClose"
    >
      <div class="operate-container">
        <ioc-tab-group
          ref="tabs"
          class="tabs"
          :option="tabOptions"
          @change="handleChange"
        ></ioc-tab-group>

        <!-- 步骤条 -->
        <div class="step-container">
          <el-scrollbar style="flex: 1" v-if="stepList.length">
            <el-timeline style="padding: 16px" class="timeLine">
              <el-timeline-item
                :timestamp="'步骤名称：' + item.stepName"
                placement="top"
                v-for="(item, index) in stepList"
                :key="index"
              >
                <!-- <p class="action"> -->
                <div class="step-row">
                  <i class="el-icon-edit" @click="editStep(item, index)"></i>
                  <i class="el-icon-delete" @click="deleteStep(item, index)"></i>
                </div>
                <!-- </p> -->
                <el-card class="step-cord">
                  <h4>
                    操作类型：{{ item.operationKeyType == 2 ? "固定输入" : "键盘输入" }}
                  </h4>
                  <p>内容：{{ item.inputContentStr }}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
            <!-- <el-steps simple :active="stepList.length" >
              <el-step
                :title="item.stepName"
                v-for="(item, index) in stepList"
                :key="index"
              >
                <template slot="description">
                  <div class="step-row">
                    <i class="el-icon-edit" @click="editStep(item, index)"></i>
                    <i class="el-icon-delete" @click="deleteStep(item, index)"></i>
                  </div>
                </template>
              </el-step>
            </el-steps> -->
          </el-scrollbar>

          <!-- 新增按钮 -->
          <div class="btn-container">
            <el-button type="primary" @click="add">新增步骤</el-button>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogClose"> 取消 </el-button>
      </div>
    </app-panel>
    <add-config-dialog
      ref="addDialog"
      :state="state"
      :controlType="controlType"
      :deviceId="deviceId"
      :detail="deviceDetails"
      :stepInfo="stepInfo"
      @refresh="getSteps()"
    ></add-config-dialog>
  </div>
</template>
<script>
import appPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api";
import { Dic, Cache, Base } from "$utils";
import addConfigDialog from "@src/modules/cameraList/components/addConfigDialog";
//import AddConfigDialog from '../components/addConfigDialog.vue';
export default {
  components: {
    addConfigDialog,
    appPanel,
  },
  props: {
    deviceId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editableTabs: [],
      configTypePage: {
        pageSize: 1000,
        pageNum: 1,
        total: 0,
      },
      showModal: false,
      dialogShow: false,
      tabOptions: {
        // column: Dic.find("SENU099"),
        column: [],
      },
      type: {},
      // 步骤条列表
      stepList: [
        // {
        //   title: "输入密码",
        // },
        // {
        //   title: "设备二次码",
        // },
        // {
        //   title: "按“TAB”健",
        // },
        // {
        //   title: "输入要屏蔽的设备类型",
        // },
        // {
        //   title: "按确认健",
        // },
      ],
      deviceDetails: {},

      controlType: "", //海湾CGS200  GTS200-1   GTS500 GTS500-1 2.物联网  北大JBF11FS-1  JBF11FS-2
      state: 1, // 1: 新增 2：修改
      stepInfo: {},
    };
  },
  mounted() {
    // this.type = this.tabOptions.column[0];
  },
  methods: {
    // 获取模块类型配置并默认加载第一项
    getConfigTypeList() {
      this.stepList = [];
      let params = {
        deviceId: this.deviceId,
        pageNum: this.configTypePage.pageNum,
        pageSize: this.configTypePage.pageSize,
      };
      this.$fetch(api.queryConfigTypeList, params).then((res) => {
        if (res && res.success) {
          this.tabOptions.column = res.returnObj.list.map((item) => {
            return {
              label: item.operationConfigTypeName,
              value: item.operationConfigTypeCode,
            };
          });
          this.configTypePage.total = res.returnObj ? res.returnObj.total : 0;
          this.type = res.returnObj.list[0];
          this.tabOptions.column.length && this.getSteps();
        } else {
          this.$message.error(res.msgContent || "获取数据失败");
        }
      });
    },
    open() {
      this.getDeviceDetail();
      this.getConfigTypeList();
      this.dialogShow = true;
    },
    dialogClose() {
      this.dialogShow = false;
    },
    // 切换选项卡
    handleChange(column) {
      console.log(column);
      this.type = column;
      this.getSteps();
    },
    showConfigDialog(deviceId) {
      this.dialogShow = true;
      this.deviceId = deviceId;
      console.log(this.deviceId, "=====this.deviceId");
    },
    add() {
      this.state = 1;
      this.$nextTick(() => {
        this.$refs.addDialog.open(this.type.value);
      });
    },
    // 获取操作步骤列表
    getSteps() {
      console.log(this.deviceId, "============");
      let params = {
        deviceId: this.deviceId,
        operationConfigType: this.type.value,
      };
      this.$fetch(api.config.queryConfigList, params).then((res) => {
        if (res && res.success) {
          this.stepList = res.returnObj;
        } else {
          this.$message.error("获取步骤失败");
        }
      });
    },
    // 查询设备详情
    getDeviceDetail() {
      let params = {
        deviceId: this.deviceId,
      };
      this.$fetch(api.config.getDeviceDetail, params).then((res) => {
        if (res && res.success) {
          let detail = res.returnObj.deviceInfo;
          if (!detail) {
            this.$message.error("暂无设备信息");
            return;
          }
          this.deviceDetails = res.returnObj.deviceInfo;
          if (this.deviceDetails.deviceType == "27") {
            // controlType 海湾CGS200  GTS200-1   GTS500 GTS500-1 2.物联网  北大JBF11FS-1  JBF11FS-2
            // FactoryId 1北大  2海湾 -1未知
            if (this.deviceDetails.subDeviceMark) {
              // 部件parentDeviceVersion/deviceVersion
              this.controlType = Dic.findByValue(
                "SENU095",
                this.deviceDetails.parentDeviceVersion
              );
            } else {
              // 主机
              this.controlType = Dic.findByValue(
                "SENU095",
                this.deviceDetails.deviceVersion
              );
            }
          } else {
            this.controlType = 2;
          }
        } else {
          this.$message.error("获取设备详情失败");
        }
      });
    },
    // 修改步骤内容
    editStep(data, index) {
      this.stepInfo = data;
      this.state = 2;
      this.$nextTick(() => {
        this.$refs.addDialog.open(this.type.value);
      });
    },
    // 删除步骤
    deleteStep(data, index) {
      let params = {
        operationConfigCode: data.operationConfigCode,
      };
      this.$fetch(api.config.deleteConfigStep, params).then((res) => {
        if (res && res.success) {
          this.$message.success("删除步骤成功");
          this.getSteps();
        } else {
          this.$message.error(res.msgContent || "删除步骤失败");
        }
      });
    },
    retBtn() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.dialog-app-panel {
  z-index: 10;
}

.operate-container {
  position: relative;
  height: 100%;
  .tabs {
    background: #181f2e;
    padding: 12px;
  }
  .btn-container {
    text-align: center;
    margin-top: 12px;
  }
  .timeLine {
    :deep .el-timeline-item__timestamp {
      font-size: 15px;
      color: #ffffff;
    }
    :deep .el-timeline-item {
      &:hover {
        .step-row {
          display: block;
        }
      }
    }
    .el-timeline-item__content {
      // color: #ffffff;

      p {
        margin: 12px 0;
      }

      .action {
        position: absolute;
        top: -12px;
        right: 0;
        background: #407aee;
        color: #fff;
        padding: 4px 8px;
        border-radius: 5px;
      }
    }

    :deep .el-timeline-item__node {
      box-shadow: 0px 0px 5px 4px #407aee;
    }
  }
  .step-container {
    // height: 400px;
    height: calc(100% - 70px);
    display: flex;
    flex-direction: column;
    padding: 12px;
    background: #181f2e;
    :deep .el-step__main {
      position: relative;
      display: flex;
      flex-direction: row;
    }
    :deep .step-row {
      display: none;
      color: #fff;
      width: 65px;
      position: absolute;
      top: 3px;
      right: 0;
      margin-left: 10px;
      i {
        font-size: 18px;
        margin-right: 12px;
        cursor: pointer;
        &:hover {
          @include set_theme_color(color, active-border-color);
        }
      }
    }
    .step-cord {
      color: #c3d3f5 !important;
      border: none !important;
      background-color: #0d121c !important;
      text-align: center;
    }
  }
}
</style>
